export default __webpack_public_path__ + "static/media/fuel-banner.eabcd0cc.png";